// eslint-disable-next-line no-restricted-imports
import classnames from 'classnames';

export const classNames = classnames;
